/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IRestaurantEventPerChannelView } from '../custom-actions/DataServiceEntities.g';
import { getEventsAsync } from '../custom-actions/DataActionExtension.g';

/**
 * GetEvents Input Action
 */
export class GetEventsInput implements Msdyn365.IActionInput {
    public includeFutureEvents: boolean;
    public eventTypeId: string;
    public includePastEvents: boolean;
    public pastEventDaysAllowed: number;
    constructor(includeFutureEvents: boolean, eventTypeId: string, includePastEvents: boolean, pastEventDaysAllowed: number) {
        this.includeFutureEvents = includeFutureEvents;
        this.eventTypeId = eventTypeId;
        this.includePastEvents = includePastEvents;
        this.pastEventDaysAllowed = pastEventDaysAllowed;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GETEVENTS`;
    public getCacheObjectType = () => 'GETEVENTS';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

async function getEventsAction(input: GetEventsInput, ctx: Msdyn365.IActionContext): Promise<IRestaurantEventPerChannelView[]> {
    try {
        const result = await getEventsAsync(
            { callerContext: ctx },
            input.includeFutureEvents,
            input.eventTypeId,
            input.includePastEvents,
            input.pastEventDaysAllowed
        );
        if (result) {
            return result;
        }
    } catch (error) {
        console.log('Error', error);
    }
    return [];
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IRestaurantEventPerChannelView[]>>getEventsAction,
    id: 'GetEvents'
});
